import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { z } from "zod";
import { request } from "@/api/client";

export const AppConfigSchema = z.object({
  key: z.string(),
  value: z.unknown(),
  description: z.string().nullable(),
  updated_by_admin_id: z.number().int().nullable(),
  updated_at: z.string(),
});
export type AppConfig = z.infer<typeof AppConfigSchema>;
const ListSchema = z.array(AppConfigSchema);

const KEY = ["admin", "app-config"];

export function useAppConfig() {
  return useQuery({
    queryKey: KEY,
    queryFn: ({ signal }) =>
      request({ path: "/api/admin/app-config", schema: ListSchema, signal }),
  });
}

export function usePatchAppConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (args: { key: string; value: unknown; description?: string }) =>
      request({
        method: "PATCH",
        path: `/api/admin/app-config/${encodeURIComponent(args.key)}`,
        body: { value: args.value, description: args.description },
        schema: AppConfigSchema,
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
